import React, {useState, useEffect} from 'react';
import { getInfoGlobal } from '../../../services/MadricService';
import InfoGlobalHistoriqueView from './InfoGlobalHistoriqueView';


/**
 *  InfoGlobalBase
 * @return {JSX}
 */
function InfoGlobalHistorique() {

  const [infoGlobal, setInfoGlobal] = useState([]);
  const [week, setWeek] = useState(0)
  const [date, setDate] = useState('');
 
  useEffect(() => {

    getInfoGlobals(week);
  }, []);

  async function getInfoGlobals(numWeek)
  {
    const res = await getInfoGlobal(numWeek);
    setInfoGlobal(res[0]);
    setDate(res[1]);
  }

  const previous = () => {
    setWeek((prev) => prev + 1);
    getInfoGlobals(week + 1);
  };

  const next = () => {
    setWeek((prev) => prev - 1);
    getInfoGlobals(week - 1);
  };


  return (
     <InfoGlobalHistoriqueView infoGlobal={infoGlobal} week={week} previous={previous} next={next} date={date}/>

  );
}

export default InfoGlobalHistorique;
